// @ts-expect-error problem with ts declaration exports
import {createDevEditorClient} from '@wix/editor-velo-cli-comm-api'
import type {DocumentFSUpdate, FullDocument, DocumentExternalUpdate} from '@wix/anyide-cli-types'
import {ReportableError} from '@wix/document-manager-utils'

const DEFAULT_CONNECTION_TIMEOUT = 5000

type SyncDocumentUpdateCallback = (documentUpdate: DocumentFSUpdate) => Promise<void>

export interface VeloCliService {
    connect(): Promise<FullDocument>
    syncChanges(callback: SyncDocumentUpdateCallback): void
    save(documentUpdate: DocumentExternalUpdate): Promise<void>
}

export const veloCliService = (cliWsUrl: string): VeloCliService => {
    const devEditorClient = createDevEditorClient()

    const connectToDevEditorClient = async (): Promise<FullDocument | undefined> => {
        try {
            const {document} = await devEditorClient.connect(cliWsUrl, {
                timeoutMs: DEFAULT_CONNECTION_TIMEOUT
            })

            return document
        } catch (e) {
            throw new ReportableError({
                errorType: 'failedConnectToVeloCliWS',
                message: 'Failed to establish connection with velo-cli-comm-api'
            })
        }
    }

    const connect = async (): Promise<FullDocument> => {
        const document: FullDocument | undefined = await connectToDevEditorClient()

        if (!document) {
            throw new ReportableError({
                errorType: 'failedConnectToVeloCliWS',
                message: 'Connection to velo-cli-comm-api established, but no data received'
            })
        }

        return document
    }

    const syncChanges = (callback: SyncDocumentUpdateCallback) =>
        devEditorClient.on('documentUpdate', async (documentUpdate: DocumentFSUpdate) => await callback(documentUpdate))

    const save = async (documentUpdate: DocumentExternalUpdate) => devEditorClient.syncDocumentUpdate(documentUpdate)

    return {
        connect,
        syncChanges,
        save
    }
}
